module.exports = __webpack_public_path__ + "static/img/s45.14e0a741.png";